import Store from "../../../../Store/Store";
import Translator from "../../../../Translation/Translator";
import Formatter from "../../../../Localization/Formatter";

class TypeContainer {
  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public typeIdsToBeHidden = (id) => {
    if (
      id === this.pickIdFromLabel("Settlement") ||
      id === this.pickIdFromLabel("Savings_account_deposit") ||
      id === this.pickIdFromLabel("Savings_account_withdraw") ||
      id === -1 ||
      id === -2
    ) {
      return true;
    }

    return false;
  }

  public typeIdsForContractUnitChargeTemplate = (type) => {
    const shouldShowPayableTitle = this.getPayableTypes().some(type => !type.removed);

    if (
      type.id === this.pickIdFromLabel("deposit") ||
      type.id === this.pickIdFromLabel("basic_rent") ||
      type.id === this.pickIdFromLabel("utilities") ||
      type.id === this.pickIdFromLabel("facilities") ||
      type.id === this.pickIdFromLabel("furnished") ||
      type.id === this.pickIdFromLabel("other_receivable") ||
      type.id === -2 ||
      (type.id === -1 && shouldShowPayableTitle) ||
      !type.system
    ) {
      return true;
    }

    return false;
  }

  public typeIdsForPropertyChargeTemplate = (type) => {
    const shouldShowPayableTitle = this.getPayableTypes().some(type => !type.removed);

    if (
      type.id === this.pickIdFromLabel("owner_association_contribution") ||
      type.id === this.pickIdFromLabel("other_payable") ||
      type.id === this.pickIdFromLabel("other_receivable") ||
      type.id === this.pickIdFromLabel("savings_account_deposit") ||
      type.id === -2 ||
      (type.id === -1 && shouldShowPayableTitle) ||
      !type.system
    ) {
      return true;
    }

    return false;
  }

  public getReceivableTypes(shouldFilterHiddenTypes: boolean = false): any[] {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return [];
    }

    const chargeClass = Store.getConfigurator().getState().globalTypes?.ChargeClass;
    let receivableTypes = [];

    for (const type in chargeTypes) {
      if (chargeTypes[type].chargeClassId === chargeClass[1].id && this.pickIdFromLabel("Other_receivable") !== chargeTypes[type].id) {
        receivableTypes.push(chargeTypes[type])
      }
    }

    receivableTypes = receivableTypes.filter(type => type.id !== this.pickIdFromLabel("payout_receivable") &&
      type.id !== this.pickIdFromLabel("overpaid_receivable") &&
      type.id !== this.pickIdFromLabel("refund_receivable") &&
      type.id !== this.pickIdFromLabel("credit_receivable")
    );

    receivableTypes
      .sort((type1, type2) => this.comparer(
        Formatter.checkTranslationType(Translator.trans(type1.label, {}, "", type1?.system), type1.label, type1?.system).toLowerCase(),
        Formatter.checkTranslationType(Translator.trans(type2.label, {}, "", type2?.system), type2.label, type2?.system).toLowerCase()
      ));

    receivableTypes.unshift(
      {
        agencyId: null,
        chargeClassId: 1,
        id: -2,
        label: Translator.trans("receivable").toUpperCase(),
        system: true
      }
    );

    if (shouldFilterHiddenTypes) {
      receivableTypes = receivableTypes.filter(type => !this.typeIdsToBeHidden((type.id)));
    }

    receivableTypes.push(chargeTypes[this.pickIdFromLabel("Other_receivable")]);

    return receivableTypes;
  }

  public getPayableTypes(shouldFilterHiddenTypes: boolean = false): any[] {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return [];
    }

    const chargeClass = Store.getConfigurator().getState().globalTypes?.ChargeClass;
    let payableTypes = [];

    for (const type in chargeTypes) {
      if (chargeTypes[type].chargeClassId === chargeClass[2].id && this.pickIdFromLabel("Other_payable") !== chargeTypes[type].id) {
        payableTypes.push(chargeTypes[type])
      }
    }

    payableTypes = payableTypes.filter(type => type.id !== this.pickIdFromLabel("payout_payable") &&
      type.id !== this.pickIdFromLabel("overpaid_payable") &&
      type.id !== this.pickIdFromLabel("refund_payable") &&
      type.id !== this.pickIdFromLabel("credit_payable"));


    payableTypes
      .sort((type1, type2) => this.comparer(
        Formatter.checkTranslationType(Translator.trans(type1.label, {}, "", type1?.system), type1.label, type1?.system).toLowerCase(),
        Formatter.checkTranslationType(Translator.trans(type2.label, {}, "", type2?.system), type2.label, type2?.system).toLowerCase()
      ));

    payableTypes.unshift(
      {
        agencyId: null,
        chargeClassId: 2,
        id: -1,
        label: Translator.trans("payable").toUpperCase(),
        system: true
      }
    );

    if (shouldFilterHiddenTypes) {
      payableTypes = payableTypes.filter(type => !this.typeIdsToBeHidden((type.id)));
    }

    payableTypes.push(chargeTypes[this.pickIdFromLabel("Other_payable")]);

    return payableTypes;
  }

  public getSettlementType(): any[] {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return [];
    }

    const settlementTypes = [];

    for (const type in chargeTypes) {
      if (chargeTypes[type].chargeClassId === null) {
        settlementTypes.push(chargeTypes[type])
      }
    }

    return settlementTypes;
  }

  public getPayoutReceivableType(): any[] {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return [];
    }

    const payoutTypes = [];

    for (const type in chargeTypes) {
      if (chargeTypes[type].id === this.pickIdFromLabel("payout_receivable")) {
        payoutTypes.push(chargeTypes[type])
      }
    }

    return payoutTypes;
  }

  public getPayoutPayableType(): any[] {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return [];
    }

    const payoutTypes = [];

    for (const type in chargeTypes) {
      if (chargeTypes[type].id === this.pickIdFromLabel("payout_payable")) {
        payoutTypes.push(chargeTypes[type])
      }
    }

    return payoutTypes;
  }

  public getChargeTypes = (chargeClass: string = "", shouldFilterHiddenTypes: boolean = false): any[] => {
    if (typeof chargeClass === "string" && chargeClass.length > 0) {
      if (chargeClass.toLowerCase() === "receivable") {
        return this.getReceivableTypes(shouldFilterHiddenTypes);
      }

      if (chargeClass.toLowerCase() === "payable") {
        return this.getPayableTypes(shouldFilterHiddenTypes);
      }
    }

    return [...this.getReceivableTypes(shouldFilterHiddenTypes), ...this.getPayableTypes(shouldFilterHiddenTypes)];
  }

  public getChargeTypesForChargeTemplates = (entity: string): any[] => {
    if (entity === "contract" || entity === "default") {
      return [
        ...this.getReceivableTypes(),
        // ...this.getPayableTypes()
      ].filter(type => this.typeIdsForContractUnitChargeTemplate(type));
    }

    if (entity === "property" || entity === "unit") {
      return [...this.getReceivableTypes(), ...this.getPayableTypes()].filter(type => this.typeIdsForPropertyChargeTemplate(type));
    }

    if (entity === "agencyfee") {
      return [...this.getReceivableTypes()].filter(type => this.typeIdsForContractUnitChargeTemplate(type)).filter(type => type.id !== -2)
        ;
    }
  }

  public pickIdFromLabel(label) {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;
    if (!chargeTypes) {
      return;
    }

    for (const type in chargeTypes) {
      if (chargeTypes[type].label?.toLowerCase() === label?.toLowerCase()) {
        return chargeTypes[type].id
      }
    }
  }

  public pickLabelFromId(id) {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return;
    }

    for (const type in chargeTypes) {
      if (chargeTypes[type].id === id) {
        return chargeTypes[type].label
      }
    }
  }

  public pickChargeClassIdFromId(id) {
    const chargeTypes = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!chargeTypes) {
      return;
    }

    for (const type in chargeTypes) {
      if (chargeTypes[type].id === id) {
        return chargeTypes[type].chargeClassId
      }
    }
  }
}


export default new TypeContainer();
